module.exports = __webpack_public_path__ + "img/iso.6cec2502.png";